import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import DropDown from '@/components/profile/dropDown'
import RoundBlueButton from '@/components/profile/roundBlueButton'
import { listOfSections } from "@/pages/profile/sections/idVerification/constants"

import '@/pages/profile/sections/common.css'

export default function QualificationNote(props: any) {
    const { common, profile } = useLocalTranslation();
    const qualificationNoteOptions = [
        {
            value: "Am pursing graduation",
            label: "Am pursing graduation"
        },
        {
            value: "Will do graduation soon",
            label: "Will do graduation soon"
        }
    ];


    return (
        <div className='profileSectionOfSectionCommonMainCon'>
            <p className='commonH2'>
                {profile.fields.i}
                <span className='text-[#FF2828]'>*</span>
            </p>

            {props.errMsg !== "" &&
                <p className='commonErr1'>{props.errMsg}</p>
            }

            <DropDown
                options={qualificationNoteOptions}
                value={props.value}
                onChange={(e: any) => props.handleInputChange(e, listOfSections.qualificationNote)}
                placeholder={profile.placeHolders.select}
                customDropDownIcon={true}
            />

            <div className='commonBtnCon1'>
                <RoundBlueButton
                    disabled={props.isSubmitBtnLoading}
                    onClick={() => props.handleSubmit(listOfSections.qualificationNote)}
                />
            </div>
        </div>
    );
}
